import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const twm = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        'text-small'
      ]
    }
  }
});

export function cn(...inputs: ClassValue[]) {
  return twm(clsx(inputs));
}
